import React from "react";
import * as Scrivito from "scrivito";
import { Field, Form, Formik } from "formik";
import { ModalBody, ModalFooter } from "reactstrap";
import { Button } from "components/Button";
import { FormSelect, TextInput } from "components/Inputs";
import cx from "classnames";
import { useTranslate } from "hooks";
import type { SelectOption } from "interfaces/shared.types";
import s from "./UserDetailsModal.module.scss";

export type StatusOption = SelectOption & { color: string };

export type UserFormValues = {
  name?: string;
  email?: string;
  phoneNumber?: string;
  position?: string;
  company?: string;
  country?: SelectOption;
  status?: StatusOption;
  group?: SelectOption;
  units?: SelectOption;
};

type Props = {
  handleSubmit: (values: UserFormValues) => void;
  initialValues: UserFormValues;
  isUpdate: boolean;
  countriesOptions: SelectOption[] | undefined;
  optionsList: StatusOption[] | undefined;
  group: SelectOption[] | undefined;
};

export const UserDetailsForm = Scrivito.connect(
  ({
    handleSubmit,
    initialValues,
    isUpdate,
    countriesOptions,
    optionsList,
    group,
  }: Props) => {
    const translate = useTranslate();

    return (
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnBlur={false}
      >
        <Form>
          <ModalBody className="pt-2_5 d-flex row">
            <div className="col-12 col-lg-6 flex-grow-1">
              <Field
                component={TextInput}
                name="name"
                autoFocus={true}
                data-recording-disable={true}
                label="Name*"
              />
              <Field
                component={TextInput}
                name="email"
                data-recording-disable={true}
                label="Email*"
              />
              <Field
                component={TextInput}
                name="phoneNumber"
                data-recording-disable={true}
                label="Phone Number"
              />
              <Field
                component={TextInput}
                name="position"
                wrapperClassName="mt-3"
                data-recording-disable={true}
                label="Position"
              />
              <Field
                component={TextInput}
                name="company"
                wrapperClassName="mt-3"
                data-recording-disable={true}
                label="Company"
              />
              <Field
                component={FormSelect}
                name="country"
                wrapperClassName={cx(s.fieldWithoutMarginBottom, "mt-3")}
                data-recording-disable={true}
                label="Role"
                options={countriesOptions}
              />
            </div>

            <div className="col-12 col-lg-6 flex-grow-1">
              <Field
                component={FormSelect}
                name="status"
                data-recording-disable={true}
                label="Status"
                options={optionsList}
              />
              <Field
                component={FormSelect}
                name="group"
                data-recording-disable={true}
                label="Group*"
                options={group}
              />
              <div className="d-flex justify-content-end mt-4">
                {translate("REQUIRED_FIELD_WITH_ASTERISK")}
              </div>
            </div>
          </ModalBody>

          <ModalFooter className="pt-0">
            <Button color="primary" type="submit">
              {isUpdate ? translate("TEXT_SAVE_CHANGES") : "Create User"}
            </Button>
          </ModalFooter>
        </Form>
      </Formik>
    );
  },
);
